
import './Footer.css';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaYoutube,FaTwitter, FaLinkedin } from "react-icons/fa";
import icon from '../images/icon.png';

function Footer() {
  return (
    <div className='footer-container'>     
      
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              NEWTECH
              <img src={icon} alt="My Icon" style={{ width: '25px', height: '25px', marginLeft: '5px'}} />
            </Link>
          </div>
          <small class='website-rights'>NEWTECH © 2025</small>
          <div class='social-icons'>
            <Link
              class='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <FaFacebook />
            </Link>
            <Link
              class='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <FaInstagram />
            </Link>
            <Link
              class='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <FaYoutube />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='Twitter'
            >
              <FaTwitter />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='LinkedIn'
            >
              <FaLinkedin />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;